module.exports = __webpack_public_path__ + "static/img/icon5-5.eebf5ca4.png";